import { render, staticRenderFns } from "./AttendanceIncentiveSetupGrid.vue?vue&type=template&id=ad0f2604"
import script from "./AttendanceIncentiveSetupGrid.vue?vue&type=script&lang=js"
export * from "./AttendanceIncentiveSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports